import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=488743f9"
import script from "./step4.vue?vue&type=script&lang=js"
export * from "./step4.vue?vue&type=script&lang=js"
import style0 from "./step4.vue?vue&type=style&index=0&id=488743f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports